import * as React from 'react';
import '../../sass/PageEditComponent.css';
import { Glyphicon } from 'react-bootstrap';

export default class ModalDecisionComponent extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.jumpToStory = this.jumpToStory.bind(this);
    }
    
    private jumpToStory(e:any) {
        let decisionId:number = this.props.id;
        let impact:string = this.props.impact;
        let jumpPage:string = this.props.jumpPage;
        let jumpChapter:number = this.props.jumpChapter;
        let outcome:string = this.props.outcome;
        let linkUrl:string = this.props.linkUrl;
        let move:string = this.props.move;
        let speedBonus:number = this.props.getSpeedBonus();
        if (!impact) {
            impact = "Tiny";
        }
        if (!jumpPage) {
            jumpPage = "1";
        }
        if (!jumpChapter) {
            jumpChapter = this.props.currentChapter;
        }
        if (!outcome) {
            outcome = "None"
        }
        if (!move) {
            move = "Continue"
        }
        // console.log("JUMP:", jumpChapter, jumpPage)
        this.props.decisionSelected(jumpPage, outcome, impact, move, jumpChapter, speedBonus, linkUrl, decisionId);
    }

    render() {
        return (
            <li onClick={this.jumpToStory.bind(this)}>
                <Glyphicon glyph="chevron-right" />
                {this.props.text}
            </li>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/storyModal/ModalDecisionComponent.tsx